import Text from '@raydiant/raydial/components/Text';
import PresentationCard from './PresentationCard';
import Button from '@raydiant/raydial/components/Button';
import DisplaiAcademyThumbnail from './DisplaiAcademyThumbnail.png';
import ImagesThumbnail from './ImagesThumbnail.svg';
import InstagramThumbnail from './InstagramThumbnail.svg';

export interface EmptyLibraryPros {
  onNewPresentation: () => void;
  onPresentationCardClick: (applicationId: string) => void;
}

const INSTAGRAM_APP_ID = 'a0853ff6-f790-4743-80fe-246e9d29eba1';
const IMAGES_APP_ID = '2058e0f9-8d7e-4ca0-946d-cb93e3f305b2';

const EmptyLibrary = ({
  onPresentationCardClick,
  onNewPresentation,
}: EmptyLibraryPros) => {
  return (
    <div className="min-h-[490px] flex flex-1 flex-col items-center text-black">
      <Text className="text-xl font-bold mb-3 mt-[74px]">
        It's a little quite in here
      </Text>
      <Text variant="caption">
        You can add folders, apps and more! Try some below:
      </Text>
      <div className="flex my-[46px] flex-wrap gap-6">
        <PresentationCard
          img={DisplaiAcademyThumbnail}
          label="Learn more about Libraries"
          onClick={() =>
            window.open('https://www.youtube.com/watch?v=iBZLRufqTAA', '_blank')
          }
        />
        <PresentationCard
          img={ImagesThumbnail}
          label="Create Images presentation"
          onClick={() => onPresentationCardClick(IMAGES_APP_ID)}
        />
        <PresentationCard
          img={InstagramThumbnail}
          label="Create Instagram presentation"
          onClick={() => onPresentationCardClick(INSTAGRAM_APP_ID)}
        />
      </div>
      <Button onPress={onNewPresentation}>Create a Presentation</Button>
    </div>
  );
};

export default EmptyLibrary;
